<template>
  <div v-if="showPendingOrderModal">
    <generic-modal
      v-if="!isCompact"
      @close="toggleCompact"
      :width="viewallModalDim.width"
      :height="'auto'"
      :animationStyle="viewallModalDim.animationStyle"
      :overflowNotNeeded="'0'"
      :contentScroll="1"
      :padding="'16px 16px 16px 16px'"
    >
      <template v-slot:header></template>
      <template v-slot:body>
        <div class="pending-order-container">
          <div class="vertical-layout">
            <img
              src="../../../default/images/global/black-cross.png"
              class="close-icon"
              @click="toggleCompact"
            />
            <div class="order-confirmation-timer">
              <div class="timer-container">
                <svg :width="size" :height="size" class="progress-ring">
                  <circle
                    class="progress-ring__background"
                    :stroke-width="stroke"
                    fill="transparent"
                    :r="radius"
                    :cx="center"
                    :cy="center"
                  />
                  <circle
                    class="progress-ring__circle"
                    :stroke-width="stroke"
                    fill="transparent"
                    :r="radius"
                    :cx="center"
                    :cy="center"
                    :stroke-dasharray="circumference"
                    :stroke-dashoffset="progressOffset"
                  />
                </svg>
                <div class="timer-text">{{ formattedTime }}</div>
              </div>
            </div>
            <div class="text-section">
              <p class="pending-text-header color-gray">{{ pendingHeader }}</p>
              <p class="pending-text-msg color-gray">{{ pendingMsg }}</p>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer></template>
    </generic-modal>

    <div v-if="isCompact" class="pending-order-container">
      <div class="border-bottom horizontal-layout">
        <div v-if="!UNKNOWN_ORDER_STATES.includes(getOrderStatus?.status)" class="order-confirmation-timer">
          <div class="timer-container">
            <svg :width="size" :height="size" class="progress-ring">
              <circle
                class="progress-ring__background"
                :stroke-width="stroke"
                fill="transparent"
                :r="radius"
                :cx="center"
                :cy="center"
              />
              <circle
                class="progress-ring__circle"
                :stroke-width="stroke"
                fill="transparent"
                :r="radius"
                :cx="center"
                :cy="center"
                :stroke-dasharray="circumference"
                :stroke-dashoffset="progressOffset"
              />
            </svg>
            <div class="timer-text">{{ formattedTime }}</div>
          </div>
        </div>
        <div class="text-section">
          <div class="flex-row">
            <p class="pending-text-header color-gray">{{ pendingHeader }}</p>
            <div v-if="UNKNOWN_ORDER_STATES.includes(getOrderStatus?.status)" class="ml8 pt3">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_763_15546)">
                <path d="M9 0.75C4.44375 0.75 0.75 4.44375 0.75 9C0.75 13.5562 4.44375 17.25 9 17.25C13.5562 17.25 17.25 13.5562 17.25 9C17.25 4.44375 13.5562 0.75 9 0.75ZM8.98312 2.87025H8.98538C8.98913 2.87025 8.9925 2.87025 8.99625 2.87025C8.997 2.87025 8.99813 2.87025 8.99925 2.87025C10.4831 2.87025 11.901 3.4995 13.0012 4.488L3.66375 11.871C3.1635 10.998 2.87063 10.0132 2.87063 8.99925C2.87063 5.796 5.77987 2.88 8.98312 2.87025ZM14.3359 6.12825C14.8357 7.00125 15.1283 7.98562 15.1283 8.99925C15.1279 12.2085 12.2085 15.1279 8.99925 15.1283C7.51575 15.1283 6.09863 14.4994 4.99875 13.5116L14.3359 6.12825Z" fill="#E31837"/>
                </g>
                <defs>
                <clipPath id="clip0_763_15546">
                <rect width="18" height="18" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <p class="pending-text-msg color-gray">{{ pendingMsg }}</p>
        </div>
        <img v-if="UNKNOWN_ORDER_STATES.includes(getOrderStatus?.status)"
          src="../../../default/images/global/nxg-expand.svg"
          class="expand-icon"
          @click="redirectToNextPost"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import { pendingOrderConstant } from "../helpers/paymentConstants";
import {
  NG_TRACK_CAMPAIGN_KEY,
  PWA_WORKSPACE_ID,
  SHOW_NG_TRACK_VARIATION,
} from "../helpers/xlabsConstants";
import { getVariationNameForCampaignKey } from "xlabs-sdk";
import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility";
import { keyMapsAction, keyMapsMutation } from '../helpers/storeKeys';
import {
  paymentsProjectBasePathWithFolder,
  v2PwaBasePath,
  isDesktop,
  isCorporateSite
} from "../config/apiEndpoints";
import setEvents from "../helpers/events";

export default {
  name: "PendingOrderModal",
  components: { GenericModal },
  data() {
    return {
      viewallModalDim: {
        width: "100%",
        minHeightBody: "216px",
        maxHeightBody: "216px",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "top-40per",
      },
      CONFIRMED_ORDER_STATES: ['SUCCESS', 'INPROCESS'],
      UNKNOWN_ORDER_STATES: ['UNKNOWN', 'FAILED'],
      ORDER_TYPE: {
        DELIVERY: 'D',
        TAKEAWAY: 'T',
        PICKUP: 'P',
        IRCTC: 'IRCTC',
        DINEIN: 'DINEIN',
        CURB: 'CURB'
      },
      isCompact: JSON.parse(localStorage.getItem("IS_PENDING_MODAL_COMPACT") || "false"),
      totalTime: 0,
      timeLeft: 0,
      timer: null,
    };
  },
  watch: {
    getOrderState: {
      immediate: true,
      handler() {
        this.postorderPageRedirect();
      },
    },
    getOrderStatus: {
      immediate: true,
      handler() {
        this.postorderPageRedirect();
      },
    },
    isCompact: {
      immediate: true,
      handler(newVal) {
        localStorage.setItem("IS_PENDING_MODAL_COMPACT", JSON.stringify(newVal));
      }
    }
  },
  mounted() {
    if (this.isCompact) {
      document.body.classList.remove("body-stop-scroll-mobile");
    }
    if(this.pendingOrderTimerLimit <= 0){
      this.resetPendingOrderModal();
    }
    this.totalTime = this.pendingOrderTimer;
    this.timeLeft = this.pendingOrderTimerLimit;
    this.fetchOrderStatus();
    this.startTimer();
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    fetchOrderStatus() {
      const transactionId = this.getOrderTransactionId;
      if(!transactionId){
        this.$store.commit("NxgTrackOrder/updateShowPendingOrderModal", false);
        document.body.classList.remove("body-stop-scroll-mobile");
        return;
      }
      const transtnObj = {
        urlParam: {
          $transactionId: transactionId,
        },
        queryStringHash: {
          fetchOrderSummaryOnWait: true,
        },
        ...this.transactionApiHitProp,
      };
      this.$store.dispatch(
        keyMapsAction.GET_TRANSACTION_CONFIRMATION,
        transtnObj
      );
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) this.timeLeft--;
        else {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    postorderPageRedirect() {
      if (
        this.CONFIRMED_ORDER_STATES.includes(this.getOrderState)
      ) {
        LocalStorageFunc.setLocalStorageValue(
          "tracker_id_mobile",
          JSON.stringify({
            orderId: this.getOrderStatus?.orderSummary.dominosOrderId,
            mobile: this.getOrderStatus?.orderSummary.deliveryPhoneNumber,
          })
        );
        sessionStorage.setItem(
          "tracker_id_mobile",
          JSON.stringify({
            orderId: this.getOrderStatus?.orderSummary.dominosOrderId,
            mobile: this.getOrderStatus?.orderSummary.deliveryPhoneNumber,
          })
        );
        localStorage.setItem("orderHistoryId", this.getOrderStatus?.orderSummary.id);
        localStorage.setItem("ORDER_TRACKING_ID", this.getOrderStatus?.orderSummary.id);

        LocalStorageFunc.setLocalStorageValue(
          "showCheesyRewardAfterCart",
          true
        );
        LocalStorageFunc.setLocalStorageValue(
          "SHOW_APP_BANNER_AND_HIDE_APP_CAROUSEL",
          false
        );
      }
      if (this.getOrderState === "SUCCESS") {
        LocalStorageFunc.clearStoreData();
        if(!this.isCompact){
          this.redirectToNextPost();
        } else {
          this.resetPendingOrderModal();
          window.location.reload();
        }
      }
      const currOrderStatus = this.getOrderStatus?.status;
      if (currOrderStatus == "UNKNOWN" || currOrderStatus == "FAILED") {
        LocalStorageFunc.clearStoreData();
        if(!this.isCompact){
          this.redirectToNextPost();
        } else {
          this.resetPendingOrderKeys();
        }
      }
    },
    redirectToNextPost() {
      this.resetPendingOrderModal();
      const ngPostOrderVariation = getVariationNameForCampaignKey(
        PWA_WORKSPACE_ID,
        NG_TRACK_CAMPAIGN_KEY
      );
      if (
        this.deliveryType === this.ORDER_TYPE.PICKUP ||
        this.deliveryType === this.ORDER_TYPE.DINEIN
      ) {
        window.location = `/thankYou?transactionId=${this.getOrderTransactionId}`;
      } else {
        if (!this.isAdvanceOrder && 
          (isCorporateSite || (ngPostOrderVariation && ngPostOrderVariation === SHOW_NG_TRACK_VARIATION) || isDesktop)
        ) {
          const newTrackingPage = paymentsProjectBasePathWithFolder + "/ngpostorder";
          window.location.replace(newTrackingPage);
        } else {
          window.location.replace("/thankYouAndTracking");
        }
      }
    },
    toggleCompact() {
      if(!this.isCompact){
        this.isCompact = !this.isCompact;
      }
      document.body.classList.remove("body-stop-scroll-mobile");
      const preEventObj = {
        screenName: 'order pending screen',
        sectionName: 'order pending screen',
        eventCategory: 'order pending impression',
        eventAction: 'order confirmation is in progress',
        eventLabel: 'order confirmation is in progress',
        orderId: this.getOrderId
      };
      const eventObject = Utility.amplitudeEventObj(
        'impression_order_pending',
        "order pending screen",
        "1",
        preEventObj
      );
      setEvents("amplitude", 'impression_order_pending', eventObject);
    },
    resetPendingOrderModal() {
      this.$store.commit("NxgTrackOrder/updateShowPendingOrderModal", false);
      this.resetPendingOrderKeys();
    },
    resetPendingOrderKeys() {
      localStorage.setItem('pendingOrderConfirmationTimer',0);
      localStorage.setItem('pendingOrderConfirmationTimerLimit',0);
      localStorage.setItem('orderSubmitInitiated', false);
      localStorage.setItem("IS_PENDING_MODAL_COMPACT", false);
    }
  },
  computed: {
    showPendingOrderModal() {
      const flag = this.$store.state.NxgTrackOrder?.showPendingOrderModal;
      if (flag) {
        const preEventObj = {
          screenName: 'order pending screen',
          sectionName: 'order pending screen',
          eventCategory: 'Popup',
          eventAction: 'order confirmation is in progress',
          eventLabel: 'impression',
          orderId: this.getOrderId
        };
        const eventObject = Utility.amplitudeEventObj(
          'impression',
          "order pending screen",
          "1",
          preEventObj
        );
        setEvents("amplitude", 'Impression', eventObject);
      }
      return flag;
    },
    pendingOrderTimerLimit() {
      return LocalStorageFunc.getPendingOrderConfirmationTimerLimit();
    },
    pendingOrderTimer() {
      return LocalStorageFunc.getPendingOrderConfirmationTimer();
    },
    stroke() {
      return this.isCompact ? 4 : 5;
    },
    size() {
      return this.isCompact ? 60 : 80;
    },
    radius() {
      return (this.size - this.stroke) / 2;
    },
    center() {
      return this.size / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    progressOffset() {
      const progress = this.timeLeft / this.totalTime;
      return this.circumference * (1 - progress);
    },
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60);
      const seconds = this.timeLeft % 60;
      return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    },
    pendingOrders() {
      return this.$store.state.NxgTrackOrder?.activeOrders?.pendingOrders || [];
    },
    getOrderTransactionId() {
      return this.pendingOrders[0]?.orderTransactionId || "";
    },
    getOrderId() {
      return this.pendingOrders[0]?.orderId || "";
    },
    getOrderStatus() {
      return this.$store.state.NxgTrackOrder.orderStatus;
    },
    getOrderState() {
      return this.$store.state.NxgTrackOrder.orderStatus?.orderSummary?.orderState || "";
    },
    deliveryType() {
      return this.$store.state.NxgTrackOrder.orderStatus?.orderSummary?.deliveryType || "";
    },
    isAdvanceOrder() {
      return this.$store.state.NxgTrackOrder.orderStatus?.orderSummary?.advanceOrder || false;
    },
    pendingHeader() {
      if(this.UNKNOWN_ORDER_STATES.includes(this.getOrderStatus?.status) && this.isCompact){
        return pendingOrderConstant.failedHeaderText;
      } else {
        return pendingOrderConstant.headerText;
      }
    },
    pendingMsg() {
      if(this.UNKNOWN_ORDER_STATES.includes(this.getOrderStatus?.status) && this.isCompact){
        return pendingOrderConstant.failedMsgText;
      } else {
        return pendingOrderConstant.msgText;
      }
    },
    transactionApiHitProp() {
      return {
        apiHitInterval: this.$store.state.Config.appConfig.config?.orderConfirmationInterval || 4,
        apiHitTime: this.pendingOrderTimerLimit || 80,
      };
    },
  },
};
</script>

<style></style>
